type RtCondition = {
  client_id: string
  permission_type: number
  request_able: boolean
}

type UnknownRecord = Record<string, any>

type DownloadItemVm = {
  $firebase: { user: { uid: string } }
  $deviceLib: { isMobileDevice: boolean }
  $site: { appFlag: string }
  $axios: { post: (url: string, data: FormData, config: { timeout: number }) => Promise<any> }
  $varuna: { endPoints: { displayDialog: string } }
  $globalVar: UnknownRecord
}

export function useDownloadItemAutoRt (vm: DownloadItemVm) {
  const hasRequestable = (rtconditions: RtCondition[], clientId: string, permissionType: number) => {
    const matched = rtconditions.find(item =>
      item.client_id === clientId && item.permission_type === permissionType
    )
    return !!(matched && matched.request_able)
  }

  const hasOldAndNewRequestable = (rtconditions: RtCondition[], clientId: string, newPermissionType: number, oldPermissionType: number) => {
    return hasRequestable(rtconditions, clientId, oldPermissionType) &&
      hasRequestable(rtconditions, clientId, newPermissionType)
  }

  const displayDialog = (formatid: string, clientId: string, permissionType: number) => {
    const formData = new FormData()
    formData.append('uuid', vm.$firebase.user.uid)
    formData.append('format_id', formatid)
    formData.append('dialog_name', 'auto_rt')
    formData.append('client_id', clientId)
    formData.append('permission_type', String(permissionType))
    formData.append('device_flg', vm.$deviceLib.isMobileDevice ? 'SP' : 'PC')
    formData.append('version', '2')
    formData.append('site_flag', 'r')
    formData.append('app_flag', vm.$site.appFlag)
    vm.$axios.post(vm.$varuna.endPoints.displayDialog, formData, { timeout: 60000 }).catch((error: unknown) => {
      console.error('[useDownloadItemAutoRt] displayDialog failed', {
        formatid,
        clientId,
        permissionType,
        error
      })
    })
  }

  const setRoxx = (rtconditions: RtCondition[], basicData: UnknownRecord, formatId: string, formatData: UnknownRecord, otherFormatData: UnknownRecord) => {
    if (hasOldAndNewRequestable(rtconditions, 'roxx_api', 10, 1)) {
      if (vm.$globalVar.checkAutoRT(basicData, formatId, formatData, otherFormatData, 10, 'roxx_api')) {
        vm.$globalVar.isAutoRTable = true
        vm.$globalVar.isAutoRT4Rtable = true
        displayDialog(formatId, 'roxx_api', 10)
        return true
      }

      vm.$globalVar.isAutoRTable = false
      vm.$globalVar.isAutoRT4Rtable = false
      return false
    }
    return false
  }

  const setRecruitMc = (rtconditions: RtCondition[], basicData: UnknownRecord, formatId: string, formatData: UnknownRecord, otherFormatData: UnknownRecord) => {
    if (hasOldAndNewRequestable(rtconditions, 'recruit_mc_mail', 3, 1)) {
      if (vm.$globalVar.checkAutoRT(basicData, formatId, formatData, otherFormatData, 3, 'recruit_mc_mail')) {
        vm.$globalVar.isAutoRTable = true
        vm.$globalVar.isAutoRT4Rtable = true
        displayDialog(formatId, 'recruit_mc_mail', 3)
        vm.$globalVar.oldPermissionType4RT = 1
        return true
      } else {
        vm.$globalVar.isAutoRTable = false
        vm.$globalVar.isAutoRT4Rtable = false
        return false
      }
    }
    return false
  }

  const setNeocareer = (rtconditions: RtCondition[], basicData: UnknownRecord, formatId: string, formatData: UnknownRecord, otherFormatData: UnknownRecord) => {
    if (hasOldAndNewRequestable(rtconditions, 'neocareer_admin', 4, 1)) {
      if (vm.$globalVar.checkAutoRT(basicData, formatId, formatData, otherFormatData, 4, 'neocareer_admin')) {
        vm.$globalVar.isAutoRTable = true
        vm.$globalVar.isAutoRT4Rtable = true
        displayDialog(formatId, 'neocareer_admin', 4)
        vm.$globalVar.oldPermissionType4RT = 1
        return true
      } else {
        vm.$globalVar.isAutoRTable = false
        vm.$globalVar.isAutoRT4Rtable = false
        return false
      }
    }
    return false
  }

  const setXMile = (rtconditions: RtCondition[], basicData: UnknownRecord, formatId: string, formatData: UnknownRecord, otherFormatData: UnknownRecord, permissionType: number, oldpermissionType: number) => {
    if (hasOldAndNewRequestable(rtconditions, 'xmile_mail', permissionType, oldpermissionType)) {
      if (vm.$globalVar.checkAutoRT(basicData, formatId, formatData, otherFormatData, permissionType, 'xmile_mail')) {
        vm.$globalVar.isAutoRTable = true
        vm.$globalVar.isAutoRT4Rtable = true
        vm.$globalVar.permissionType4RT = permissionType
        displayDialog(formatId, 'xmile_mail', permissionType)
        vm.$globalVar.oldPermissionType4RT = oldpermissionType
        return true
      } else {
        vm.$globalVar.isAutoRTable = false
        vm.$globalVar.isAutoRT4Rtable = false
        return false
      }
    }
    return false
  }

  const setPharmate = (rtconditions: RtCondition[], basicData: UnknownRecord, formatId: string, formatData: UnknownRecord, otherFormatData: UnknownRecord, permissionType: number, oldpermissionType: number) => {
    if (hasOldAndNewRequestable(rtconditions, 'pharmate_mail', permissionType, oldpermissionType)) {
      if (vm.$globalVar.checkAutoRT(basicData, formatId, formatData, otherFormatData, permissionType, 'pharmate_mail')) {
        vm.$globalVar.isAutoRTable = true
        vm.$globalVar.isAutoRT4Rtable = true
        vm.$globalVar.permissionType4RT = permissionType
        displayDialog(formatId, 'pharmate_mail', permissionType)
        vm.$globalVar.oldPermissionType4RT = oldpermissionType
        return true
      } else {
        vm.$globalVar.isAutoRTable = false
        vm.$globalVar.isAutoRT4Rtable = false
        vm.$globalVar.permissionType4RT = 0
        return false
      }
    }
    return false
  }

  const setAutoRT = (rtconditions: RtCondition[], basicData: UnknownRecord, formatId: string, formatData: UnknownRecord, otherFormatData: UnknownRecord, permissionType: number, oldpermissionType: number, clientId: string) => {
    if (hasOldAndNewRequestable(rtconditions, clientId, permissionType, oldpermissionType)) {
      if (vm.$globalVar.checkAutoRT(basicData, formatId, formatData, otherFormatData, permissionType, clientId)) {
        vm.$globalVar.isAutoRTable = true
        vm.$globalVar.isAutoRT4Rtable = true
        vm.$globalVar.permissionType4RT = permissionType
        displayDialog(formatId, clientId, permissionType)
        return true
      } else {
        console.error('checkAutoRT Non success')
        vm.$globalVar.isAutoRTable = false
        vm.$globalVar.isAutoRT4Rtable = false
        vm.$globalVar.permissionType4RT = 0
        return false
      }
    }
    return false
  }

  const setAutoRTNewOnly = (rtconditions: RtCondition[], basicData: UnknownRecord, formatId: string, formatData: UnknownRecord, otherFormatData: UnknownRecord, permissionType: number, clientId: string) => {
    if (hasRequestable(rtconditions, clientId, permissionType)) {
      if (vm.$globalVar.checkAutoRT(basicData, formatId, formatData, otherFormatData, permissionType, clientId)) {
        vm.$globalVar.isAutoRTable = true
        vm.$globalVar.isAutoRT4Rtable = true
        vm.$globalVar.permissionType4RT = permissionType
        displayDialog(formatId, clientId, permissionType)
        return true
      } else {
        vm.$globalVar.isAutoRTable = false
        vm.$globalVar.isAutoRT4Rtable = false
        vm.$globalVar.permissionType4RT = 0
        return false
      }
    }
    return false
  }

  return {
    setRoxx,
    setRecruitMc,
    setNeocareer,
    setXMile,
    setPharmate,
    setAutoRT,
    setAutoRTNewOnly
  }
}
